import React, { useEffect, useState } from "react";
import { Table, Row, Col, Button, Modal, Form, Input, message, Tabs, Space, Select, Popconfirm } from "antd";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axios from "axios";
import dayjs from "dayjs";
import App from "../../Utils/LayoutMobile";

// ── Theme Constants ──
const C_PINK      = "#F04DA0";
const C_PURPLE    = "#8B2FC9";
const C_GRAD      = `linear-gradient(135deg, ${C_PINK}, ${C_PURPLE})`;
const C_SOFT_BG   = "#F8F4FF";
const C_TEXT_MAIN = "#1a0040";
const C_TEXT_MUTED= "#64748B";

// ── Icons ──
const SearchIcon = () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;
const ExcelIcon = () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="15" x2="15" y2="15"/><line x1="9" y1="11" x2="15" y2="11"/><line x1="9" y1="19" x2="15" y2="19"/></svg>;
const EditIcon = () => <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const UserIcon = () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const MailIcon = () => <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>;
const PhoneIcon = () => <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const CheckIcon = () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>;
const TrashIcon = () => <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>;
const ReplyIcon = () => <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></svg>;
const GmailIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z" stroke="#EA4335" strokeWidth="1.5"/><path d="M2 6l10 7 10-7" stroke="#EA4335" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const OutlookIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="2" y="4" width="20" height="16" rx="2" stroke="#0078D4" strokeWidth="1.5"/><path d="M2 8h20M8 8v12" stroke="#0078D4" strokeWidth="1.5"/></svg>;
const ExternalIcon = () => <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>;

// ── Section Label ──
function SectionLabel({ children }) {
  return (
    <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:14 }}>
      <span style={{ fontSize:11, fontWeight:700, letterSpacing:"0.16em", textTransform:"uppercase", color:C_PINK, whiteSpace:"nowrap" }}>{children}</span>
      <span style={{ flex:1, height:1.5, background:`linear-gradient(90deg, rgba(240,77,160,0.35), transparent)`, borderRadius:2 }}/>
    </div>
  );
}

// Payment status options matching your enum
const PAYMENT_STATUS_OPTIONS = [
  { value: "pending",   label: "Pending",   color: "#d97706", bg: "#fffbeb", border: "#fde68a" },
  { value: "completed", label: "Completed", color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0" },
  { value: "failed",    label: "Failed",    color: "#ef4444", bg: "#fef2f2", border: "#fecaca" },
];

const RegisterUser = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Edit modal
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form] = Form.useForm();

  // Payment status modal
  const [statusModal, setStatusModal] = useState({ visible: false, row: null, value: "" });
  const [statusLoading, setStatusLoading] = useState(false);

  // Reply modal
  const [replyModal, setReplyModal] = useState({ visible: false, email: "" });

  const [searchText, setSearchText] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  // ── Fetch Users ──
  const fetchUsers = async () => {
    setLoading(true);
    try {
      let statusValue = "";
      let isCOD = false;

      if (activeTab === "paid")    statusValue = "completed";
      else if (activeTab === "pending") statusValue = "pending";
      else if (activeTab === "unpaid")  statusValue = "failed";
      else if (activeTab === "cod")     isCOD = true;

      const statusQuery  = statusValue ? `status=${statusValue}` : "";
      const keywordQuery = searchText  ? `keyword=${searchText}` : "";
      const queryParams  = [statusQuery, keywordQuery].filter(Boolean).join("&");

      const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/userRegistration/registerUser${queryParams ? `?${queryParams}` : ""}`;
      const response = await axios.get(url);

      if (response.data.status === "success") {
        const rawUsers = response.data.data;
        const filteredByCOD = isCOD
          ? rawUsers.filter((item) => item.payment?.paymentMode === "cod")
          : rawUsers;

        const transformedUsers = filteredByCOD.map((item, index) => {
          const typesSet = new Set(item.selectedSessions?.map((s) => s.conferenceType));
          const types = Array.from(typesSet).join(" & ");
          return {
            key:              item._id,
            srNo:             index + 1,
            RegistrationName: item.RegistrationName || "",
            RegistrationMobile: item.RegistrationMobile || "",
            firstName:        item.user?.name || "",
            lastName:         item.user?.lName || "",
            email:            item.user?.email || "",
            mobileNumber:     item.user?.mobile || "",
            whatsappNumber:   item.user?.whatAppNumber || "",
            conferenceType:   types || "-",
            qualification:    item.user?.Qualification || "",
            totalPayable:     item.payment?.amount || 0,
            paymentStatus:    item.payment?.status || "",
            paymentMode:      item.payment?.paymentMode || "",
            isAttended:       item.isAttended,
            createdAt:        item.createdAt,
            originalData:     item,
          };
        });

        setUsers(transformedUsers);
        setFilteredUsers(transformedUsers);
      } else {
        message.error("Failed to fetch users: unexpected response");
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setUsers([]);
        setFilteredUsers([]);
      } else {
        message.error("Failed to fetch users");
      }
    }
    setLoading(false);
  };

  useEffect(() => { fetchUsers(); /* eslint-disable-next-line */ }, [activeTab]);

  useEffect(() => {
    if (!searchText) {
      setFilteredUsers(users);
    } else {
      const s = searchText.toLowerCase();
      setFilteredUsers(users.filter((u) => {
        const fullName = `${u.firstName} ${u.lastName}`.toLowerCase();
        return fullName.includes(s) || (u.email || "").toLowerCase().includes(s);
      }));
    }
  }, [searchText, users]);

  // ── Edit ──
  const handleEdit = (row) => {
    setEditingUser(row.originalData);
    form.setFieldsValue({
      RegistrationName:   row.RegistrationName,
      RegistrationMobile: row.RegistrationMobile,
      firstName:          row.firstName,
      lastName:           row.lastName,
      email:              row.email,
      mobileNumber:       row.mobileNumber,
      whatsappNumber:     row.whatsappNumber,
      qualification:      row.qualification,
    });
    setIsModalVisible(true);
  };

  // ✅ FIXED: edit now sends correct payload matching your updateRegistration controller
  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/userRegistration/updateUserRegistration/${editingUser._id}`,
        {
          RegistrationName:   values.RegistrationName,
          RegistrationMobile: values.RegistrationMobile,
        }
      );
      message.success("Registration updated successfully");
      setIsModalVisible(false);
      fetchUsers();
    } catch (err) {
      console.error("Update error:", err.response?.data || err.message);
      message.error("Failed to update registration");
    }
  };

  // ── Payment Status Change ──
  const openStatusModal = (row) => {
    setStatusModal({ visible: true, row, value: row.paymentStatus });
  };

  const handleStatusUpdate = async () => {
    setStatusLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/userRegistration/updatePaymentStatus/${statusModal.row.originalData._id}`,
        { status: statusModal.value }
      );
      message.success(`Payment status updated to "${statusModal.value}"`);
      setStatusModal({ visible: false, row: null, value: "" });
      fetchUsers();
    } catch (err) {
      console.error("Status update error:", err.response?.data || err.message);
      message.error("Failed to update payment status");
    } finally {
      setStatusLoading(false);
    }
  };

  // ── Delete ──
  const handleDelete = async (row) => {
    try {
      setLoading(true);
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/userRegistration/deleteRegistration/${row.originalData._id}`
      );
      message.success("Registration deleted successfully");
      fetchUsers();
    } catch (err) {
      console.error("Delete error:", err.response?.data || err.message);
      message.error("Failed to delete registration");
    } finally {
      setLoading(false);
    }
  };

  // ── Reply (email picker) ──
  const openReplyModal = (row) => {
    setReplyModal({ visible: true, email: row.email || "" });
  };

  const handleReplyOption = (type) => {
    const email = replyModal.email;
    if (!email) { message.warning("No email found for this delegate"); return; }

    const subject = encodeURIComponent("Conference Registration - Reply");
    const body    = encodeURIComponent("Dear Delegate,\n\nThank you for registering.\n\nRegards,\nConference Team");

    if (type === "gmail") {
      window.open(`https://mail.google.com/mail/?view=cm&to=${email}&su=${subject}&body=${body}`, "_blank");
    } else if (type === "outlook") {
      window.open(`https://outlook.live.com/mail/0/deeplink/compose?to=${email}&subject=${subject}&body=${body}`, "_blank");
    } else {
      window.open(`mailto:${email}?subject=${subject}&body=${body}`);
    }
    setReplyModal({ visible: false, email: "" });
  };

  // ── Attendance ──
  const handleAttendanceToggle = async (row) => {
    try {
      setLoading(true);
      const updatedStatus = !row.isAttended;
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/userRegistration/updateUserRegistration/${row.originalData._id}`,
        { isAttended: updatedStatus }
      );
      message.success(`Attendance marked as ${updatedStatus ? "Present" : "Absent"}`);
      if (updatedStatus) {
        try {
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/certificate`, { registrationId: row.originalData._id });
          message.success("Certificate generated and email sent!");
        } catch (certErr) {
          message.error("Failed to generate certificate");
        }
      }
      fetchUsers();
    } catch (err) {
      message.error("Failed to update attendance");
    } finally {
      setLoading(false);
    }
  };

  // ── Excel Export ──
  const handleExportExcel = () => {
    if (!filteredUsers?.length) { message.warning("No data to export"); return; }
    const exportData = filteredUsers.map((row, index) => ({
      "Sr No":               index + 1,
      "Registration Name":   row.RegistrationName || "N/A",
      "Registration Mobile": row.RegistrationMobile || "N/A",
      "Full Name":           `${row.firstName} ${row.lastName}`.trim() || "N/A",
      "Email":               row.email || "N/A",
      "Mobile Number":       row.mobileNumber || "N/A",
      "WhatsApp Number":     row.whatsappNumber || "N/A",
      "Event Type":          row.conferenceType || "N/A",
      "Qualification":       row.qualification || "N/A",
      "Total Payable (₹)":   row.totalPayable || 0,
      "Payment Status":      row.paymentStatus?.toUpperCase() || "N/A",
      "Payment Mode":        row.paymentMode || "N/A",
      "Attended":            row.isAttended ? "Yes" : "No",
      "Date & Time":         dayjs(row.createdAt).format("MMM D, YYYY - h:mm A"),
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Registrations");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf], { type: "application/octet-stream" }), `Delegate_Registrations_${dayjs().format("YYYYMMDD")}.xlsx`);
    message.success("Excel downloaded!");
  };

  // ── Status Pill Helper ──
  const getStatusMeta = (label = "") => {
    const l = label.toLowerCase();
    if (l === "completed" || l === "success") return { cls: "status-active",  display: "Completed" };
    if (l === "pending")                       return { cls: "status-warning", display: "Pending" };
    if (l === "failed" || l === "unpaid")      return { cls: "status-danger",  display: "Failed" };
    if (l === "cod")                           return { cls: "status-purple",  display: "COD" };
    return { cls: "status-draft", display: label || "Unknown" };
  };

  // ── Table Columns ──
  const columns = [
    {
      title: "Delegate Info",
      key: "name",
      render: (_, row) => (
        <div style={{ display:"flex", alignItems:"flex-start", gap:14 }}>
          <div className="avatar-wrap"><UserIcon /></div>
          <div>
            <div style={{ fontWeight:800, color:C_TEXT_MAIN, fontSize:14, marginBottom:4 }}>
              {row.RegistrationName || `${row.firstName} ${row.lastName}`}
            </div>
            <span style={{ display:"flex", alignItems:"center", gap:6, color:C_TEXT_MUTED, fontSize:12 }}>
              <span style={{ color:C_PURPLE }}><MailIcon /></span>
              {row.email || "No email"}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "Contact",
      key: "contact",
      render: (_, row) => (
        <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
          <span style={{ display:"flex", alignItems:"center", gap:6, color:C_TEXT_MAIN, fontSize:13, fontWeight:600 }}>
            <span style={{ color:C_PINK }}><PhoneIcon /></span>
            {row.RegistrationMobile || row.mobileNumber || "N/A"}
          </span>
          {row.whatsappNumber && (
            <span style={{ fontSize:11, color:C_TEXT_MUTED, fontWeight:600, paddingLeft:19 }}>
              WA: {row.whatsappNumber}
            </span>
          )}
        </div>
      ),
    },
    {
      title: "Registration",
      key: "registration",
      render: (_, row) => (
        <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
          <span style={{ fontSize:13, fontWeight:700, color:C_PURPLE }}>{row.conferenceType}</span>
          <span style={{ fontSize:11, color:C_TEXT_MUTED, textTransform:"uppercase", letterSpacing:"0.05em", fontWeight:600 }}>
            {row.qualification || "No Qualification"}
          </span>
        </div>
      ),
    },
    {
      title: "Amount",
      key: "amount",
      render: (_, row) => (
        <span style={{ fontSize:14, fontWeight:800, color:C_TEXT_MAIN }}>
          ₹ {row.totalPayable}
        </span>
      ),
    },
    {
      title: "Payment Status",
      key: "paymentStatus",
      render: (_, row) => {
        const { cls, display } = getStatusMeta(row.paymentStatus);
        return (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            <span className={`status-pill ${cls}`}>
              <span className="status-dot" /> {display}
            </span>
            {/* ── Change Status Button ── */}
           {row.paymentStatus !== "completed" && (
              <button
              className="change-status-btn"
              onClick={() => openStatusModal(row)}
              title="Change payment status"
            >
              Change Status
            </button>)}
          </div>
        );
      },
    },
    {
      title: "Attendance",
      key: "attendance",
      align: "center",
      render: (_, row) => (
        <button
          onClick={() => handleAttendanceToggle(row)}
          className={`attendance-btn ${row.isAttended ? "attended" : "not-attended"}`}
        >
          {row.isAttended ? <><CheckIcon /> Attended</> : "Mark Present"}
        </button>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, row) => (
        <div style={{ display:"flex", alignItems:"center", gap:6, justifyContent:"center" }}>
          {/* Edit */}
          <button className="action-btn edit-btn" onClick={() => handleEdit(row)} title="Edit">
            <EditIcon />
          </button>

          {/* Reply */}
          <button className="action-btn reply-btn" onClick={() => openReplyModal(row)} title="Reply via Email">
            <ReplyIcon />
          </button>

          {/* Delete */}
          <Popconfirm
            title="Delete Registration"
            description="Are you sure you want to delete this registration? This cannot be undone."
            onConfirm={() => handleDelete(row)}
            okText="Yes, Delete"
            cancelText="Cancel"
            okButtonProps={{ danger: true }}
          >
            <button className="action-btn delete-btn" title="Delete">
              <TrashIcon />
            </button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <App>
      <div className="lc">
        <div className="mw">

          {/* ── Header ── */}
          <div className="header-flex">
            <div>
              <SectionLabel>Delegate Management</SectionLabel>
              <h1 className="sec-title">Registered <span style={{ color:C_PINK }}>Users</span></h1>
              <p className="sec-sub">Manage registrations, payments, and track delegate attendance.</p>
            </div>
          </div>

          {/* ── Controls ── */}
          <div className="controls-section">
            <div className="search-wrap">
              <span className="search-icon"><SearchIcon /></span>
              <input
                type="text"
                className="custom-search-input"
                placeholder="Search by name or email..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <button className="btn-outline-premium" onClick={handleExportExcel}>
              <ExcelIcon /> Export to Excel
            </button>
          </div>

          {/* ── Tabs & Table ── */}
          <div className="glass">
  <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key)} className="premium-tabs">
    <Tabs.TabPane tab="All Registrations" key="all" />
    <Tabs.TabPane tab="Paid" key="paid" />
    <Tabs.TabPane tab="Pending" key="pending" />
    <Tabs.TabPane tab="Failed / Unpaid" key="unpaid" />
    <Tabs.TabPane tab="Pay on Desk (COD)" key="cod" />
  </Tabs>
  {/* ← scroll wrapper फक्त table ला */}
  <div className="table-scroll-wrap">
    <Table
      columns={columns}
      dataSource={filteredUsers}
      rowKey="key"
      loading={loading}
      pagination={{ pageSize:10, position:["bottomCenter"] }}
      className="premium-table"
      scroll={{ x: 900 }} 
    />
  </div>
</div>

          {/* ══════════════════════════════════════
              ── EDIT MODAL ──
          ══════════════════════════════════════ */}
          <Modal
            title={<span style={{ fontWeight:800, color:C_TEXT_MAIN, fontSize:18 }}>Edit Delegate</span>}
            open={isModalVisible}
            onCancel={() => { setIsModalVisible(false); form.resetFields(); }}
            destroyOnClose
            footer={null}
            className="premium-modal"
          >
            <Form form={form} layout="vertical" preserve={false} onFinish={handleUpdate} className="premium-form" style={{ marginTop:20 }}>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item label="Registration Name" name="RegistrationName" rules={[{ required:true, message:"Required" }]}>
                    <Input placeholder="Full name as registered" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Registration Mobile" name="RegistrationMobile" rules={[{ required:true, message:"Required" }]}>
                    <Input placeholder="Mobile number" />
                  </Form.Item>
                </Col>
              </Row>

              {/* Read-only user info for reference */}
              <div className="info-box">
                <span style={{ fontSize:11, fontWeight:700, color:C_PURPLE, textTransform:"uppercase", letterSpacing:"0.1em" }}>
                  User Account Info (read-only)
                </span>
                <div style={{ marginTop:8, display:"flex", flexDirection:"column", gap:4 }}>
                  <span style={{ fontSize:13, color:C_TEXT_MUTED }}>
                    <strong>Name:</strong> {editingUser ? (editingUser.user?.name || "-") : "-"}
                  </span>
                  <span style={{ fontSize:13, color:C_TEXT_MUTED }}>
                    <strong>Email:</strong> {editingUser ? (editingUser.user?.email || "-") : "-"}
                  </span>
                  <span style={{ fontSize:13, color:C_TEXT_MUTED }}>
                    <strong>Mobile:</strong> {editingUser ? (editingUser.user?.mobile || "-") : "-"}
                  </span>
                </div>
              </div>

              <div style={{ display:"flex", justifyContent:"flex-end", gap:12, marginTop:24 }}>
                <Button onClick={() => { setIsModalVisible(false); form.resetFields(); }} style={{ borderRadius:50, fontWeight:600 }}>
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit" style={{ background:C_GRAD, border:"none", borderRadius:50, fontWeight:600 }}>
                  Save Changes
                </Button>
              </div>
            </Form>
          </Modal>

          {/* ══════════════════════════════════════
              ── PAYMENT STATUS MODAL ──
          ══════════════════════════════════════ */}
          <Modal
            title={
              <div>
                <div style={{ fontWeight:800, color:C_TEXT_MAIN, fontSize:18 }}>Update Payment Status</div>
                {statusModal.row && (
                  <div style={{ fontSize:13, color:C_TEXT_MUTED, fontWeight:400, marginTop:4 }}>
                    {statusModal.row.RegistrationName} · ₹{statusModal.row.totalPayable}
                  </div>
                )}
              </div>
            }
            open={statusModal.visible}
            onCancel={() => setStatusModal({ visible:false, row:null, value:"" })}
            footer={null}
            className="premium-modal"
          >
            <div style={{ marginTop:20 }}>
              <p style={{ fontSize:13, color:C_TEXT_MUTED, marginBottom:16 }}>
                Select new payment status for this registration:
              </p>

              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {PAYMENT_STATUS_OPTIONS.map((opt) => (
                  <button
                    key={opt.value}
                    onClick={() => setStatusModal((prev) => ({ ...prev, value: opt.value }))}
                    style={{
                      padding:"14px 20px",
                      borderRadius:12,
                      border: statusModal.value === opt.value
                        ? `2px solid ${opt.color}`
                        : `1.5px solid ${opt.border}`,
                      background: statusModal.value === opt.value ? opt.bg : "#fff",
                      color: opt.color,
                      fontWeight:700,
                      fontSize:14,
                      cursor:"pointer",
                      textAlign:"left",
                      transition:"all 0.2s",
                      display:"flex",
                      alignItems:"center",
                      gap:10,
                    }}
                  >
                    <span style={{
                      width:10, height:10, borderRadius:"50%",
                      background: opt.color,
                      display:"inline-block",
                      boxShadow: statusModal.value === opt.value ? `0 0 0 3px ${opt.bg}` : "none",
                    }}/>
                    {opt.label}
                    {statusModal.value === opt.value && (
                      <span style={{ marginLeft:"auto", fontSize:12 }}>✓ Selected</span>
                    )}
                  </button>
                ))}
              </div>

              <div style={{ display:"flex", justifyContent:"flex-end", gap:12, marginTop:24 }}>
                <Button
                  onClick={() => setStatusModal({ visible:false, row:null, value:"" })}
                  style={{ borderRadius:50, fontWeight:600 }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  loading={statusLoading}
                  onClick={handleStatusUpdate}
                  style={{ background:C_GRAD, border:"none", borderRadius:50, fontWeight:600 }}
                >
                  Update Status
                </Button>
              </div>
            </div>
          </Modal>

          {/* ══════════════════════════════════════
              ── REPLY MODAL (like your screenshot) ──
          ══════════════════════════════════════ */}
          <Modal
            open={replyModal.visible}
            onCancel={() => setReplyModal({ visible:false, email:"" })}
            footer={null}
            width={360}
            centered
            className="reply-modal"
            closable={false}
          >
            <div style={{ textAlign:"center", padding:"8px 0 16px" }}>
              {/* Back icon */}
              <div style={{
                width:48, height:48, borderRadius:"50%",
                background:"rgba(139,47,201,0.08)",
                display:"flex", alignItems:"center", justifyContent:"center",
                margin:"0 auto 16px",
                color:C_PURPLE,
              }}>
                <ReplyIcon />
              </div>

              <div style={{ fontSize:15, color:C_TEXT_MUTED, marginBottom:4 }}>Reply to</div>
              <div style={{ fontSize:15, fontWeight:700, color:C_PURPLE, marginBottom:24, wordBreak:"break-all" }}>
                {replyModal.email}
              </div>

              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {/* Gmail */}
                <button className="reply-option-btn" onClick={() => handleReplyOption("gmail")}>
                  <GmailIcon /> <span>Gmail Web</span>
                </button>
                {/* Outlook */}
                <button className="reply-option-btn" onClick={() => handleReplyOption("outlook")}>
                  <OutlookIcon /> <span>Outlook Web</span>
                </button>
                {/* Default */}
                <button className="reply-option-btn" onClick={() => handleReplyOption("default")}>
                  <ExternalIcon /> <span>Default App</span>
                </button>
              </div>

              <button
                onClick={() => setReplyModal({ visible:false, email:"" })}
                style={{
                  marginTop:20, background:"none", border:"none",
                  color:C_TEXT_MUTED, cursor:"pointer", fontSize:14,
                  fontWeight:600, padding:"8px 24px", borderRadius:50,
                  transition:"color 0.2s",
                }}
              >
                Cancel
              </button>
            </div>
          </Modal>

        </div>
      </div>

      {/* ── Global Styles ── */}
      <style>{`
        * { box-sizing: border-box; }
        .lc { font-family: 'Segoe UI', sans-serif; background: ${C_SOFT_BG}; min-height: 100vh; padding: 40px 0 80px; }
        .mw { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

        .header-flex { display:flex; align-items:flex-end; justify-content:space-between; margin-bottom:24px; gap:20px; flex-wrap:wrap; }
        .sec-title { font-size: clamp(28px,4vw,38px); font-weight:800; color:${C_TEXT_MAIN}; letter-spacing:-0.02em; line-height:1.15; margin:0 0 8px; }
        .sec-sub { font-size:15px; color:${C_TEXT_MUTED}; margin:0; }

        .controls-section { display:flex; align-items:center; justify-content:space-between; margin-bottom:24px; gap:16px; flex-wrap:wrap; }
        .search-wrap { position:relative; flex:1; max-width:400px; }
        .search-icon { position:absolute; left:16px; top:50%; transform:translateY(-50%); color:${C_TEXT_MUTED}; display:flex; align-items:center; }
        .custom-search-input { width:100%; padding:12px 16px 12px 42px; border-radius:50px; border:1px solid rgba(139,47,201,0.15); background:#fff; color:${C_TEXT_MAIN}; font-size:14.5px; outline:none; transition:all 0.3s; box-shadow:0 4px 12px rgba(0,0,0,0.02); }
        .custom-search-input:focus { border-color:${C_PINK}; box-shadow:0 0 0 3px rgba(240,77,160,0.1); }

        .btn-outline-premium { display:inline-flex; align-items:center; gap:8px; padding:12px 24px; background:#fff; border:1px solid rgba(139,47,201,0.3); border-radius:50px; color:${C_PURPLE}; font-size:14px; font-weight:700; cursor:pointer; transition:all 0.2s; box-shadow:0 4px 12px rgba(0,0,0,0.02); }
        .btn-outline-premium:hover { background:#faf6fe; border-color:${C_PURPLE}; transform:translateY(-2px); }

        .avatar-wrap { width:42px; height:42px; border-radius:12px; background:linear-gradient(135deg,rgba(139,47,201,0.1),rgba(240,77,160,0.1)); border:1px solid rgba(139,47,201,0.15); color:${C_PURPLE}; display:flex; align-items:center; justify-content:center; flex-shrink:0; }

        /* Status pills */
        .status-pill { display:inline-flex; align-items:center; gap:6px; padding:4px 10px; border-radius:50px; font-size:11px; font-weight:700; letter-spacing:0.05em; text-transform:uppercase; width:fit-content; }
        .status-dot { width:6px; height:6px; border-radius:50%; }
        .status-active  { background:#f0fdf4; color:#16a34a; border:1px solid #bbf7d0; } .status-active .status-dot  { background:#16a34a; }
        .status-warning { background:#fffbeb; color:#d97706; border:1px solid #fde68a; } .status-warning .status-dot { background:#d97706; }
        .status-danger  { background:#fef2f2; color:#ef4444; border:1px solid #fecaca; } .status-danger .status-dot  { background:#ef4444; }
        .status-purple  { background:#faf5ff; color:#c026d3; border:1px solid #f5d0fe; } .status-purple .status-dot  { background:#c026d3; }
        .status-draft   { background:#f8f9fa; color:#64748b; border:1px solid #e2e8f0; } .status-draft .status-dot   { background:#94a3b8; }

        /* Change status button */
        .change-status-btn { padding:5px 12px; border-radius:50px; border:1px dashed rgba(139,47,201,0.35); background:transparent; color:${C_PURPLE}; font-size:11px; font-weight:700; cursor:pointer; transition:all 0.2s; white-space:nowrap; letter-spacing:0.04em; }
        .change-status-btn:hover { background:rgba(139,47,201,0.06); border-color:${C_PURPLE}; }

        /* Attendance */
        .attendance-btn { display:inline-flex; align-items:center; justify-content:center; gap:6px; padding:8px 16px; border-radius:50px; font-size:12.5px; font-weight:700; cursor:pointer; transition:all 0.2s; white-space:nowrap; border:1px solid transparent; }
        .attendance-btn.attended     { background:#16a34a; color:#fff; box-shadow:0 4px 12px rgba(22,163,74,0.3); }
        .attendance-btn.not-attended { background:#fff; color:${C_TEXT_MUTED}; border-color:#e2e8f0; }
        .attendance-btn.not-attended:hover { border-color:${C_PINK}; color:${C_PINK}; background:rgba(240,77,160,0.05); }

        /* Action buttons */
        .action-btn { width:36px; height:36px; border-radius:10px; border:none; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:all 0.2s; }
        .edit-btn   { background:rgba(139,47,201,0.08); color:${C_PURPLE}; }
        .edit-btn:hover   { background:rgba(139,47,201,0.15); transform:translateY(-2px); }
        .reply-btn  { background:rgba(16,163,127,0.08); color:#10a37f; }
        .reply-btn:hover  { background:rgba(16,163,127,0.15); transform:translateY(-2px); }
        .delete-btn { background:rgba(239,68,68,0.08); color:#ef4444; }
        .delete-btn:hover { background:rgba(239,68,68,0.15); transform:translateY(-2px); }

        /* Glass table card */
        .glass { background:#fff; border-radius:20px; padding:12px 24px 24px; border:1px solid rgba(139,47,201,0.08); box-shadow:0 10px 40px rgba(0,0,0,0.04); overflow:hidden; }
        .table-scroll-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 0 0 16px 16px;
}
.table-scroll-wrap::-webkit-scrollbar {
  height: 5px;
}
.table-scroll-wrap::-webkit-scrollbar-track {
  background: #f1f0f7;
  border-radius: 10px;
}
.table-scroll-wrap::-webkit-scrollbar-thumb {
  background: rgba(139,47,201,0.25);
  border-radius: 10px;
}
.table-scroll-wrap::-webkit-scrollbar-thumb:hover {
  background: rgba(139,47,201,0.5);
}

        /* Info box inside edit modal */
        .info-box { background:#faf6fe; border:1px solid rgba(139,47,201,0.12); border-radius:12px; padding:14px 16px; margin-bottom:4px; }

        /* Ant Design overrides */
        .premium-tabs .ant-tabs-nav { margin-bottom:0 !important; }
        .premium-tabs .ant-tabs-tab { padding:16px 0; font-weight:600; color:${C_TEXT_MUTED}; }
        .premium-tabs .ant-tabs-tab-active .ant-tabs-tab-btn { color:${C_PINK} !important; }
        .premium-tabs .ant-tabs-ink-bar { background:${C_PINK} !important; height:3px !important; border-radius:3px 3px 0 0; }

        .premium-table .ant-table { background:transparent !important; font-family:inherit; }
        .premium-table .ant-table-thead > tr > th { background:transparent !important; color:${C_TEXT_MUTED}; font-weight:700; font-size:12.5px; text-transform:uppercase; letter-spacing:0.05em; border-bottom:2px solid rgba(139,47,201,0.08); padding:20px 16px; }
        .premium-table .ant-table-thead > tr > th::before { display:none !important; }
        .premium-table .ant-table-tbody > tr > td { border-bottom:1px solid rgba(139,47,201,0.05); padding:20px 16px; transition:background 0.3s; vertical-align:middle; }
        .premium-table .ant-table-tbody > tr:hover > td { background:#fcfaff !important; }
        .premium-table .ant-pagination { margin-top:24px !important; }
        .premium-table .ant-pagination-item-active { border-color:${C_PINK}; background:rgba(240,77,160,0.05); }
        .premium-table .ant-pagination-item-active a { color:${C_PINK} !important; }

        .premium-modal .ant-modal-content { border-radius:20px; padding:24px; }
        .premium-form .ant-form-item-label > label { font-weight:600 !important; color:${C_TEXT_MAIN} !important; font-size:13.5px !important; }
        .premium-form .ant-input { padding:10px 16px !important; border-radius:10px !important; border:1px solid rgba(139,47,201,0.15) !important; background:#faf6fe !important; color:${C_TEXT_MAIN} !important; font-size:14.5px !important; transition:all 0.3s; }
        .premium-form .ant-input:focus, .premium-form .ant-input:hover { border-color:${C_PINK} !important; background:#fff !important; box-shadow:0 0 0 3px rgba(240,77,160,0.1) !important; }

        /* Reply modal */
        .reply-modal .ant-modal-content { border-radius:24px; padding:28px; }
        .reply-option-btn { width:100%; padding:14px 20px; border-radius:12px; border:1px solid #e8e8f0; background:#fff; font-size:14px; font-weight:600; color:${C_TEXT_MAIN}; cursor:pointer; display:flex; align-items:center; gap:12px; transition:all 0.2s; }
        .reply-option-btn:hover { background:#faf6fe; border-color:rgba(139,47,201,0.25); transform:translateX(4px); }

        @media(max-width:768px) {
          .glass { padding:12px; border-radius:16px; }
          .controls-section { flex-direction:column; align-items:stretch; }
          .search-wrap { max-width:100%; }
        }
      `}</style>
    </App>
  );
};

export default RegisterUser;
